module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/th_5-740a6aad388c9dd642dae2f03098ccd7.jpg";